import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PhoneFilledSvg from "@ant-design/icons-svg/es/asn/PhoneFilled";
import AntdIcon from '../components/AntdIcon';
var PhoneFilled = function PhoneFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: PhoneFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(PhoneFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'PhoneFilled';
}
export default RefIcon;